/* eslint-disable import/prefer-default-export */
import { useLocation } from 'react-router-dom';
import { MODEL_CARD_GRID_USAGE, MODEL_CARD_GRID_USAGE_URLS, variant1, variant2 } from './constants';
/**
 * Stores a variety of props which change value depending on what site the user is on
 *
 *  @returns {object} - Returns an object containing the prop values based on the variant
 * @param variant
 */
export const useConfiguration = (variant) => {
    let isFilterItemBold = false;
    switch (variant) {
        // HONDA_SITE_NAME
        case variant1:
            break;
        // ACURA_SITE_NAME
        case variant2:
            isFilterItemBold = true;
            break;
        default:
            break;
    }
    return { isFilterItemBold };
};
/**
 * Returns a named string for possible pages card component is used
 * returns {string}
 */
export const getComponentUsage = (pathname) => {
    var _a;
    if (!pathname)
        return MODEL_CARD_GRID_USAGE.UNKNOWN;
    if ((_a = MODEL_CARD_GRID_USAGE_URLS[MODEL_CARD_GRID_USAGE.INVENTORY]) === null || _a === void 0 ? void 0 : _a.some(url => { var _a; return (_a = pathname.toLocaleLowerCase().includes(url)) !== null && _a !== void 0 ? _a : false; })) {
        return MODEL_CARD_GRID_USAGE.INVENTORY;
    }
    return MODEL_CARD_GRID_USAGE.UNKNOWN;
};
/**
 * Checks the url for the page and determine where the card grid is used
 * @returns {ModelCardGridLocation}
 */
export const useModelCardGridLocation = () => {
    const { pathname } = useLocation() || {};
    const componentLocation = getComponentUsage(pathname);
    return { componentLocation };
};
